import React from "react";
import {
  TextField,
  FormControlLabel,
  Switch,
  Typography,
  Divider,
} from "@material-ui/core";

export const DEFAULT_INTERACTION_SETTINGS = {
  timeoutEnabled: false,
  timeoutMinutes: 5,
  timeoutMessage: "",
  maxInvalidAttempts: 3,
  invalidMessage: "Opção inválida. Escolha uma das opções disponíveis.",
};

export function mergeInteractionSettings(data = {}) {
  return {
    timeoutEnabled: !!data.timeoutEnabled,
    timeoutMinutes:
      data.timeoutMinutes != null && data.timeoutMinutes !== ""
        ? Number(data.timeoutMinutes)
        : DEFAULT_INTERACTION_SETTINGS.timeoutMinutes,
    timeoutMessage: data.timeoutMessage ?? "",
    maxInvalidAttempts:
      data.maxInvalidAttempts != null && data.maxInvalidAttempts !== ""
        ? Number(data.maxInvalidAttempts)
        : DEFAULT_INTERACTION_SETTINGS.maxInvalidAttempts,
    invalidMessage:
      data.invalidMessage ?? DEFAULT_INTERACTION_SETTINGS.invalidMessage,
  };
}

/**
 * Campos compartilhados de timeout e respostas inválidas nos modais de interação.
 */
export default function FlowBuilderInteractionSettings({
  values,
  onChange,
  showTimeout = true,
  showInvalid = true,
}) {
  const set = (key, value) => onChange({ ...values, [key]: value });

  return (
    <>
      {showTimeout && (
        <>
      <Divider style={{ margin: "16px 0" }} />
      <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 700 }}>
        Timeout (sem resposta)
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={!!values.timeoutEnabled}
            onChange={(e) => set("timeoutEnabled", e.target.checked)}
            color="primary"
          />
        }
        label="Ativar mensagem após tempo sem resposta"
      />
      {values.timeoutEnabled && (
        <>
          <TextField
            label="Tempo sem resposta (minutos)"
            type="number"
            fullWidth
            margin="dense"
            variant="outlined"
            value={values.timeoutMinutes ?? 5}
            onChange={(e) => set("timeoutMinutes", e.target.value)}
            inputProps={{ min: 1 }}
          />
          <TextField
            label="Mensagem de timeout (ex: Oi, ainda está aí?)"
            fullWidth
            margin="dense"
            variant="outlined"
            multiline
            rows={2}
            value={values.timeoutMessage ?? ""}
            onChange={(e) => set("timeoutMessage", e.target.value)}
            placeholder="Oi, ainda está aí?"
          />
          <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>
            Conecte o handle vermelho &quot;Sem resposta&quot; para redirecionar após o timeout.
            Sem conexão, só envia a mensagem e continua aguardando.
          </Typography>
        </>
      )}
        </>
      )}

      {showInvalid && (
        <>
      <Divider style={{ margin: "16px 0" }} />
      <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 700 }}>
        Respostas inválidas
      </Typography>
      <TextField
        label="Máximo de tentativas inválidas"
        type="number"
        fullWidth
        margin="dense"
        variant="outlined"
        value={values.maxInvalidAttempts ?? 3}
        onChange={(e) => set("maxInvalidAttempts", e.target.value)}
        inputProps={{ min: 1 }}
      />
      <TextField
        label="Mensagem de opção inválida"
        fullWidth
        margin="dense"
        variant="outlined"
        multiline
        rows={2}
        value={values.invalidMessage ?? ""}
        onChange={(e) => set("invalidMessage", e.target.value)}
      />
      <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>
        Conecte o handle &quot;Opção inválida&quot; para redirecionar após esgotar as tentativas.
      </Typography>
        </>
      )}
    </>
  );
}
